export const blockIconsImageAutoStories = (
	<span className='material-symbols-outlined'>auto_stories</span>
);
